import { useMemo } from 'react';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import useUserStore from '@lcsc-ui/store/user';

const ServiceCenterDialog = ({ headBuriedPoint }) => {
  const { commonConfigVO } = useUserStore();

  const dataList = useMemo(
    () => [
      {
        id: 1,
        icon: 'qq-active',
        title: '4000800709',
        tip: '点击QQ咨询',
        op: 'qq',
        pointer: true,
      },
      {
        id: 2,
        icon: 'phone-active',
        title: commonConfigVO?.salesmanVO?.phoneNo || '0755-83865666',
        tip: '拨打电话咨询',
        op: 'phone',
        pointer: false,
      },
    ],
    [commonConfigVO]
  );

  const _loadQQ = function () {
    const name = 'qqWindow';
    const iHeight = 600;
    const iWidth = 750;
    const iTop = (window.screen.height - 30 - iHeight) / 2; //获得窗口的垂直位置;
    const iLeft = (window.screen.width - 10 - iWidth) / 2; //获得窗口的水平位置;
    window.open(
      'https://wpa1.qq.com/zohvG78r?_type=wpa&qidian=true',
      name,
      'height=' +
        iHeight +
        ',innerHeight=' +
        iHeight +
        ',width=' +
        iWidth +
        ',innerWidth=' +
        iWidth +
        ',top=' +
        iTop +
        ',left=' +
        iLeft +
        ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no'
    );
  };

  function handleServiceItemClick({ id, op }) {
    if (id === 1) {
      _loadQQ();
    }
    if (op === 'qq') {
      const href = window.location.href;
      headBuriedPoint(op, href);
    } else {
      headBuriedPoint(op);
    }
  }

  return (
    <ul>
      {dataList.map((data, idx) => (
        <li
          key={data.id}
          className={`${[1].includes(idx) ? 'mb-[0]' : 'mb-[16px]'} ${data.pointer ? 'cursor-pointer' : ''} flex items-center`}
        >
          <SvgIcon app="common" iconName={data.icon} className="size-[30px]" />
          <section className="ml-[10px]" onClick={() => handleServiceItemClick(data)}>
            <p className={`text-[14px] ${[1].includes(idx) ? 'text-black' : 'text-lcBlue'} leading-[20px]`}>
              {data.title}
            </p>
            <p className="text-[12px] text-[#54657D] leading-[20px]">{data.tip}</p>
          </section>
        </li>
      ))}
    </ul>
  );
};

export default ServiceCenterDialog;
